import { isFloodPolicy } from "./is-flood-policy";

export const matchesCarrierGroupOrFlood = (
  carrierGroup: string | null | undefined,
  policyType: string | null | undefined,
  carrierGroups: readonly string[],
): boolean => {
  const normalizedCarrierGroup = carrierGroup?.toLowerCase() ?? "";
  return (
    carrierGroups.includes(normalizedCarrierGroup) ||
    isFloodPolicy(carrierGroup, policyType)
  );
};
